/* footer.js — Nude Project style footer behaviour
   Handles: accordion menus, store carousel, shutter-line scroll reveal,
   and the fixed-logo reveal height calculation. */

(function () {
  'use strict';

  document.querySelectorAll('[data-nf-root]').forEach(initFooter);

  function initFooter(root) {
    initAccordions(root);
    initCarousel(root);
    initShutterLine(root);
    initFixedLogoHeight(root);
  }

  /* ---------------------------------------------------------------------
     Accordion (Brand / Support / Boring stuff)
     --------------------------------------------------------------------- */
  function initAccordions(root) {
    var accordions = root.querySelectorAll('[data-nf-accordion]');

    accordions.forEach(function (accordion) {
      var trigger = accordion.querySelector('[data-nf-accordion-trigger]');
      var panel = accordion.querySelector('[data-nf-accordion-panel]');
      if (!trigger || !panel) return;

      // Start closed.
      panel.style.maxHeight = '0px';

      trigger.addEventListener('click', function () {
        var isOpen = accordion.classList.contains('is-open');

        if (isOpen) {
          // Close
          panel.style.maxHeight = '0px';
          accordion.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          // Open — measure the natural height and animate to it.
          panel.style.maxHeight = panel.scrollHeight + 'px';
          accordion.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Keep open panels correctly sized if the viewport is resized
    // (e.g. text reflow changing content height, or switching to desktop
    // where accordions are always visible via CSS).
    window.addEventListener('resize', debounce(function () {
      accordions.forEach(function (accordion) {
        var panel = accordion.querySelector('[data-nf-accordion-panel]');
        if (!panel) return;
        if (accordion.classList.contains('is-open')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    }, 150));
  }

  /* ---------------------------------------------------------------------
     Store carousel
     --------------------------------------------------------------------- */
  function initCarousel(root) {
    var carousel = root.querySelector('[data-nf-carousel]');
    if (!carousel) return;

    var track = carousel.querySelector('[data-nf-track]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-nf-slide]'));
    var prevBtn = carousel.querySelector('[data-nf-prev]');
    var nextBtn = carousel.querySelector('[data-nf-next]');
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-nf-dot]'));
    var storeNames = Array.prototype.slice.call(carousel.querySelectorAll('[data-nf-store-name]'));
    var storeAddresses = Array.prototype.slice.call(carousel.querySelectorAll('[data-nf-store-address]'));

    if (!track || slides.length === 0) return;

    var current = 0;
    var autoplayDelay = parseInt(carousel.getAttribute('data-autoplay-delay'), 10) || 4000;
    var autoplayTimer = null;

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });

      storeNames.forEach(function (el, i) {
        el.hidden = i !== current;
      });
      storeAddresses.forEach(function (el, i) {
        el.hidden = i !== current;
      });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(next, autoplayDelay);
    }
    function stopAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    goTo(0);
    startAutoplay();
  }

  /* ---------------------------------------------------------------------
     Shutter-line scroll reveal (the thin animated line above the
     newsletter/menu row)
     --------------------------------------------------------------------- */
  function initShutterLine(root) {
    var line = root.querySelector('[data-shutter-line]');
    if (!line || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          line.classList.add('nf-top--in');
          line.classList.remove('nf-top--out');
        } else {
          line.classList.add('nf-top--out');
          line.classList.remove('nf-top--in');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(line);
  }

  /* ---------------------------------------------------------------------
     Fixed logo reveal — measure the oversized logo's height and expose
     it as --footer-logo-height so footer.site-footer's margin-bottom
     creates the scroll gap that reveals it.
     --------------------------------------------------------------------- */
  function initFixedLogoHeight() {
    var logo = document.getElementById('footer-logo-fixed-target');
    if (!logo) return;

    function setHeight() {
      document.documentElement.style.setProperty(
        '--footer-logo-height',
        logo.getBoundingClientRect().height + 'px'
      );
    }

    setHeight();
    window.addEventListener('resize', debounce(setHeight, 150));
    window.addEventListener('load', setHeight);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(setHeight);
    }
  }

  /* ---------------------------------------------------------------------
     Utility
     --------------------------------------------------------------------- */
  function debounce(fn, wait) {
    var timeout;
    return function () {
      var args = arguments;
      var context = this;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }
})();
